(() => {
  'use strict';
  const root = document.querySelector('[data-guya-us-waitlist]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const openButton = root.querySelector('[data-guya-us-open]');
  const closeButton = root.querySelector('[data-guya-us-close]');
  const status = root.querySelector('[data-guya-us-status]');
  let eligible = false;
  let autoTimer;
  const dismissalKey = 'guya-us-waitlist-dismissed-v1';
  const dismissed = () => { try { return sessionStorage.getItem(dismissalKey) === '1'; } catch (_) { return false; } };
  const remember = () => { try { sessionStorage.setItem(dismissalKey, '1'); } catch (_) { /* Reopening remains available without storage. */ } };
  const show = () => {
    if (!eligible || dialog.open || document.visibilityState !== 'visible') return;
    const modalVisible = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some(el => el.getClientRects().length > 0);
    if (document.querySelector('dialog[open]') || modalVisible) return;
    dialog.showModal();
    closeButton.focus();
  };
  const close = () => { remember(); dialog.close(); };
  openButton.addEventListener('click', show);
  closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', () => remember());
  dialog.addEventListener('close', () => { if (eligible) openButton.focus({preventScroll:true}); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
  });
  const nativeReady = () => {
    const form = root.querySelector('[data-forms-id="forms-root-1196063"] shopify-forms-embed');
    const ready = Boolean(form && form.shadowRoot && form.shadowRoot.querySelector('form'));
    if (ready) status.hidden = true;
    return ready;
  };
  const mountDeadline = Date.now() + 20000;
  const mountTimer = setInterval(() => {
    if (nativeReady()) clearInterval(mountTimer);
    else if (Date.now() > mountDeadline) { clearInterval(mountTimer); status.textContent = 'The form could not load. Please refresh this page or contact support@drinkguya.com.'; }
  }, 400);
  const applyCountry = (country, preview = false) => {
    eligible = country === 'US';
    root.dataset.state = eligible ? (preview ? 'editor-preview' : 'eligible') : 'ineligible';
    document.documentElement.dataset.guyaUsState = eligible ? 'eligible' : 'ineligible';
    openButton.hidden = !eligible;
    if (!eligible) { if (dialog.open) dialog.close(); return; }
    // Native Forms inline hosts have a data-forms-id parent. Suppress only the
    // unrelated global popup host; never remove ordinary inline signup forms.
    const suppressOrdinaryPopup = () => document.querySelectorAll('shopify-forms-embed').forEach(host => {
      const parent = host.closest('[data-forms-id]');
      if (!parent || parent.dataset.formsId === 'forms-root-911995') host.remove();
    });
    suppressOrdinaryPopup();
    const popupObserver = new MutationObserver(suppressOrdinaryPopup);
    popupObserver.observe(document.body, {childList:true, subtree:true});
    window.addEventListener('pagehide', () => popupObserver.disconnect(), {once:true});
    if (!dismissed()) autoTimer = setTimeout(show, preview ? 0 : 25000);
  };
  const detect = async () => {
    if (root.dataset.preview === 'true' && window.Shopify && window.Shopify.designMode) { applyCountry('US', true); return; }
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      const localeRoot = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
      const response = await fetch(localeRoot + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {signal:controller.signal, credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Country lookup failed');
      const data = await response.json();
      applyCountry(data && data.detected_values && data.detected_values.country && data.detected_values.country.handle);
    } catch (_) {
      root.dataset.state = 'error';
      document.documentElement.dataset.guyaUsState = 'ineligible';
      openButton.hidden = true;
    } finally { clearTimeout(timeout); }
  };
  window.addEventListener('pagehide', () => { clearTimeout(autoTimer); clearInterval(mountTimer); }, {once:true});
  // BFCache restoration must recheck country after a VPN/network change.
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  detect();
})();
